import { createContext, useContext, useReducer, useCallback } from 'react';

// Estado inicial para los datos de la empresa
const initialState = {
  formData: {},
  currentStep: 0,
  isLoading: false,
  errors: {}
};

// Tipos de acciones
const ACTIONS = {
  UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
  SET_CURRENT_STEP: 'SET_CURRENT_STEP',
  SET_LOADING: 'SET_LOADING',
  SET_ERRORS: 'SET_ERRORS',
  RESET_FORM: 'RESET_FORM',
  LOAD_EXISTING_DATA: 'LOAD_EXISTING_DATA'
};

// Reducer para manejar las acciones
function empresaFormReducer(state, action) {
  switch (action.type) {
    case ACTIONS.UPDATE_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.field]: action.payload.value
        }
      };
    
    case ACTIONS.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload
      };
    
    case ACTIONS.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
    
    case ACTIONS.SET_ERRORS:
      return {
        ...state,
        errors: action.payload
      };
    
    case ACTIONS.RESET_FORM:
      return initialState;
    
    case ACTIONS.LOAD_EXISTING_DATA:
      return {
        ...state,
        formData: action.payload
      };
    
    default:
      return state;
  }
}

// Crear el contexto
const EmpresaFormContext = createContext();

// Provider del contexto
export function EmpresaFormProvider({ children }) {
  const [state, dispatch] = useReducer(empresaFormReducer, initialState);

  // Acciones disponibles
  const updateFormData = (field, value) => {
    dispatch({
      type: ACTIONS.UPDATE_FORM_DATA,
      payload: { field, value }
    });
  };

  const setCurrentStep = (step) => {
    dispatch({
      type: ACTIONS.SET_CURRENT_STEP,
      payload: step
    });
  };

  const setLoading = (loading) => {
    dispatch({
      type: ACTIONS.SET_LOADING,
      payload: loading
    });
  };

  const setErrors = (errors) => {
    dispatch({
      type: ACTIONS.SET_ERRORS,
      payload: errors
    });
  };

  const resetForm = () => {
    dispatch({
      type: ACTIONS.RESET_FORM
    });
  };

  const loadExistingData = useCallback((data) => {
    dispatch({
      type: ACTIONS.LOAD_EXISTING_DATA,
      payload: data
    });
  }, []);

  const value = {
    ...state,
    updateFormData,
    setCurrentStep,
    setLoading,
    setErrors,
    resetForm,
    loadExistingData
  };

  return (
    <EmpresaFormContext.Provider value={value}>
      {children}
    </EmpresaFormContext.Provider>
  );
}

// Hook personalizado para usar el contexto
export function useEmpresaForm() {
  const context = useContext(EmpresaFormContext);
  if (!context) {
    throw new Error('useEmpresaForm debe ser usado dentro de un EmpresaFormProvider');
  }
  return context;
}

export default EmpresaFormContext;